export enum DebuggerState {
  Idle = 0x00,
  Paused = 0x01,
  IntructionStepOver = 0x02,
}